import { gql } from '@apollo/client'
import { BlockFragment } from 'app/features/shared/blocks'
import { BaseBlock } from '../blocks.types'

export const FeaturedContentBlockFragment: BlockFragment = {
  name: 'featuredContent',
  fragment: gql`
    fragment featuredContent on FeaturedContent {
      id
      blockName
      blockType
      featuredContentTitle: title
      featuredContentDescription: description
      featuredContentLink: link
      featuredContentLinkText: linkText
      featuredContentImage: image {
        url
        alt
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
  partialFragment: `
    ...on FeaturedContent {
      id
      blockName
      blockType
      featuredContentTitle: title
      featuredContentDescription: description
      featuredContentLink: link
      featuredContentLinkText: linkText
      featuredContentImage: image {
        url
        alt
      }
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const FeaturedContentBlockType = 'featuredContent'

export interface FeaturedContentBlock extends BaseBlock {
  blockType: typeof FeaturedContentBlockType
  featuredContentTitle: string
  featuredContentDescription: string
  featuredContentLink: string
  featuredContentLinkText: string
  imagePriority?: boolean
  featuredContentImage: {
    url: string
    alt: string
  }
}
